import React from 'react';

import { MdCloudDownload } from 'react-icons/md';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { Button } from 'scouting-ui/lib';

import type { MBCRecord } from '@appTypes/esb';
import { organizationPositionSel } from '@shared/duck/selectors/general.selectors';
import { convertCSVColumnstoFile } from '@shared/utils';

import styles from './MbcSearchCsv.less';
import {
  MbcSearchCsvColumns,
  columnsKeys,
  formatCounselorsToCSVData,
  generateMbcCvsFilename,
} from './utils';

interface MbcSearchCSVProps {
  counselors: MBCRecord[];
}

const MbcSearchCSV: React.FC<MbcSearchCSVProps> = ({ counselors }) => {
  const selectedOrganization = useSelector(organizationPositionSel);

  const onPress = () => {
    const mapped = formatCounselorsToCSVData(counselors);
    const filename = generateMbcCvsFilename(selectedOrganization);

    const poListFile = convertCSVColumnstoFile<MbcSearchCsvColumns>({
      parsedCSV: mapped,
      columns: columnsKeys,
      filename,
    });

    const link = document.createElement('a');
    link.href = URL.createObjectURL(poListFile);
    link.download = `${filename}.csv`;
    link.click();

    // Clear
    URL.revokeObjectURL(link.href);
  };

  return (
    <Button
      className={styles.downloadCSV}
      onClick={onPress}
      disabled={!counselors.length}
      ghost
      size="small"
      shape="round"
    >
      <MdCloudDownload />
      <FormattedMessage id="mbc.mbcTable.csv.button" />
    </Button>
  );
};

export default MbcSearchCSV;
